var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppWindowLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0135 11.004V3.00397C29.0135 2.47353 28.8028 1.96483 28.4278 1.58975C28.0527 1.21468 27.544 1.00397 27.0135 1.00397H3.01355C2.48312 1.00397 1.97441 1.21468 1.59934 1.58975C1.22426 1.96483 1.01355 2.47353 1.01355 3.00397V25.004C1.01355 25.5344 1.22426 26.0431 1.59934 26.4182C1.97441 26.7932 2.48312 27.004 3.01355 27.004H11.0135",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01355 7.00397H29.0135",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0204 25.8426C23.0848 26.3061 23.0414 26.7782 22.8936 27.2222C22.7459 27.6662 22.4977 28.0701 22.1684 28.4026L20.4457 30.1252C19.835 30.6934 19.0277 31.0026 18.1936 30.9876C17.3596 30.9726 16.5639 30.6347 15.974 30.0449C15.3841 29.4552 15.0459 28.6596 15.0307 27.8256C15.0155 26.9915 15.3244 26.1841 15.8924 25.5732L17.615 23.8506C17.9404 23.5276 18.3348 23.2825 18.7685 23.1338C19.2022 22.9851 19.6639 22.9366 20.119 22.9919",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.851 23.0105C26.3147 23.0751 26.787 23.0319 27.2313 22.8841C27.6755 22.7363 28.0797 22.488 28.4123 22.1585L30.1336 20.4359C30.6979 19.8244 31.0038 19.0184 30.9871 18.1866C30.9705 17.3547 30.6326 16.5616 30.0443 15.9732C29.4559 15.3849 28.6628 15.047 27.8309 15.0304C26.9991 15.0137 26.193 15.3196 25.5816 15.8839L23.867 17.6065C23.5436 17.9317 23.2984 18.326 23.1496 18.7598C23.0009 19.1935 22.9526 19.6554 23.0083 20.1105",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0135 26.004L26.0135 20.004",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppWindowLink);
export default __webpack_public_path__ + "static/media/AppWindowLink.482a890fa86e06259b75362338f07ce5.svg";
export { ForwardRef as ReactComponent };